// Legacy names are confined to this API compatibility boundary.
export const CAMPAIGN_FIELDS = Object.freeze({
    LVT_CPD: "LVT Public - Certified Programs CPD",
    LVT_NASBA: "LVT Public - Certified Programs NASBA",
    LVT_DELIVERY_METHODS: "LVT Public - Certified Programs Delivery Methods",
    LVT_PRICE: "LVT Public - Certified Programs Price",
    NEOM_LVT_PRICE: "Neom LVT Public - Certified Programs Price",
    PUBLIC_PRICE: "Public - Certified Programs Price",
});

const aliases = {
    [CAMPAIGN_FIELDS.LVT_CPD]: ["LVT Public CPD"],
    [CAMPAIGN_FIELDS.LVT_NASBA]: ["LVT Public NASBA"],
    [CAMPAIGN_FIELDS.LVT_DELIVERY_METHODS]: ["LVT Public Delivery Methods"],
    [CAMPAIGN_FIELDS.LVT_PRICE]: ["LVT Public Price"],
    [CAMPAIGN_FIELDS.NEOM_LVT_PRICE]: ["Neom LVT Public Price"],
    [CAMPAIGN_FIELDS.PUBLIC_PRICE]: ["Public Price", "Neom Public Price"],
};

export const canonicalCampaignFieldName = (name) =>
    Object.keys(aliases).find((canonical) => canonical === name || aliases[canonical].includes(name)) || name;

// New field wins even when its value is 0, empty, null or undefined.
export const findCampaignField = (fields, name) => {
    if (!Array.isArray(fields)) return undefined;
    const canonical = canonicalCampaignFieldName(name);
    for (const candidate of [canonical, ...(aliases[canonical] || [])]) {
        const field = fields.find((item) => item && item.fieldName === candidate);
        if (field) return field;
    }
    return undefined;
};

// Preserve backend schema IDs and metadata. Do not submit duplicate old/new fields.
export const normalizeCampaignFields = (fields) => {
    if (!Array.isArray(fields)) return fields;
    const seen = new Set();
    return fields.reduce((result, field) => {
        if (!field || !field.fieldName) return [...result, field];
        const canonical = canonicalCampaignFieldName(field.fieldName);
        if (!aliases[canonical]) return [...result, field];
        if (!seen.has(canonical)) {
            seen.add(canonical);
            result.push({ ...findCampaignField(fields, canonical), fieldName: canonical });
        }
        return result;
    }, []);
};

export const normalizeCampaignResponse = (data) => {
    if (!data || typeof data !== "object") return data;
    const normalizeCampaign = (campaign) =>
        campaign && {
            ...campaign,
            ...(campaign.columnsList ? { columnsList: normalizeCampaignFields(campaign.columnsList) } : {}),
        };
    return {
        ...data,
        ...(data.dynamicSchemaFields ? { dynamicSchemaFields: normalizeCampaignFields(data.dynamicSchemaFields) } : {}),
        ...(data.campaign ? { campaign: normalizeCampaign(data.campaign) } : {}),
        ...(Array.isArray(data.campaignList) ? { campaignList: data.campaignList.map(normalizeCampaign) } : {}),
    };
};
